import { Link } from "gatsby"
import { Img } from "../../../../layout/Img"

export const CaseStudyCard = ({ project }) => {
  const [coverPicture] = project.coverPicture

  return (
    <div className="cursor-pointer">
      <article className="overflow-hidden rounded-lg shadow-lg">
        <Link to={`/${project.uri}`}>
          <div className="relative w-full overflow-hidden">
          <Img 
          className="card-image" 
          image={coverPicture}
          />
          </div>

          <header className="relative flex-col w-full h-40 px-6 pt-6 mt-5 overflow-hidden leading-tight ">
            {project.caseStudyCategories[0] && (
              <span className="px-2 py-1 text-xs uppercase border-2 rounded-full 2xl:text-sm text-secondary border-highlightColor">
                {project.caseStudyCategories[0].title}
              </span>
            )}
            <h2 className="mt-5 text-xl font-semibold text-secondary lg:text-xl 2xl:text-2xl">
              {project.title}
            </h2>
          </header>

          <footer className="flex flex-col justify-start px-6 pb-10 align-bottom">
            <div className="">
              <img
                alt={project.sponsor[0].title}
                referrerPolicy="no-referrer"
                className="w-2/3 md:w-2/4"
                src={project.sponsor[0].sponsorLogo[0].url}
              />
            </div>
          </footer>
        </Link>
      </article>
    </div>
  )
}
